<template>
    <div>
        <div class="navbar" mode="horizontal">
            <hamburger v-if="!pathFlag" :toggle-click="toggleSideBar" :is-active="sidebar.opened" class="hamburger-container" />
            <span class="title" :class="pathFlag ? 'm-l-50' : ''">海淘管理系统</span>
            <!-- 顶部面包屑导航 -->
            <!-- <breadcrumb></breadcrumb> -->
            <div class="user-content">
                <iframe id="iframe" v-if="play" src="https://img.ddky.com/c/wap/images/test/sounds/tip.mp3" style="display:none;" allow="autoplay"></iframe>
                <!-- http://oss.ityufeng.cn/media/index.html   http://pop.ddky.com/music/customerReportOrder.mp3 -->
                <!-- <audio v-if="play" ref="audio" autoplay="self" :src="http://pop.ddky.com/music/customerReportOrder.mp3" type="audio/mpeg"></audio> -->
                <div class="tips">
                    <router-link v-for="item in task" :key="item.uuid" :to="item.url">
                        <el-alert :title="item.msg" type="error" :closable="false"></el-alert>
                    </router-link>
                </div>
                <el-badge :value="total" v-if="total" :max="99" class="badge-item">
                    <svg-icon icon-class="notice" style="font-size:26px" />
                </el-badge>
                <el-dropdown :hide-on-click="true" placement="bottom-start" @command="handleDropdownClick" trigger="click">
                    <span class="el-dropdown-link">
                        欢迎您，{{ currentUser.name }}
                        <i class="el-icon-arrow-down el-icon--right"></i>
                    </span>
                    <el-dropdown-menu class="header-dropdown" slot="dropdown">
                        <!-- <el-dropdown-item command="changePwd">修改密码</el-dropdown-item> -->
                        <!-- 线条：divided -->
                        <el-dropdown-item command="logout">退出登录</el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
            </div>
        </div>
        <ChangePwd v-if="showPwdDialog" :dialogVisible="showPwdDialog" :userMobile="currentUser.mobile" @closeDialog="showPwdDialog = false"></ChangePwd>
    </div>
</template>

<script>
import { v4 as uuidv4 } from 'uuid'
import { mapGetters, mapActions } from 'vuex'
import Hamburger from '@/components/Hamburger'
import ChangePwd from '@/views/login/ChangePwd'
import { removeToken } from '@/utils/auth.js'
import { doLogout } from '@/api/login.js'
import Notification from '@/utils/Notification'

export default {
    components: {
        Hamburger,
        ChangePwd
    },
    data() {
        return {
            showPwdDialog: false,
            ocrRoute: false,
            count: 0,
            src: '',
            play: false,
            bell: null,
            task: [], // 消息提示队列
            pathFlag: false
        }
    },
    computed: {
        ...mapGetters(['sidebar', 'currentUser']),
        total: {
            get() {
                return this.$store.state.home.total
            },
            set(val) {
                return val
            }
        }
    },
    created() {
        // 获取公用枚举类 ↓
        // 获取当前上架类型
        this.GetShopType()
        // 获取省份列表
        this.GetProvince()
        // 获取门店
        this.GetPharmacy()
        // 子公司
        this.GetSubCompany()
        // 获取分类
        this.GetFirstClass()
        // 获取品牌
        this.GetBrand()
        // 厂商
        this.GetManufacturers()
        // 获取店铺分类下拉列表
        this.GetShopClassification()
        // 物流商列表
        this.GetDeliveryList()
        // 拼团标签
        this.GetActivityTabs()
    },
    mounted() {
        const paths = ['/shop/edit', '/activity/edit']
        this.path = this.$route.path
        this.pathFlag = paths.indexOf(this.$route.path) !== -1
        // this.bell = new Wad({ source: require('@/assets/MP3/tip.mp3') })
        // this.bell.play()
        // this.bell.stop()
        this.$nextTick(() => {
            this._getHomePageData()
        })
        this.init()
    },
    methods: {
        ...mapActions([
            'GetShopType',
            'GetSubCompany',
            'GetPharmacy',
            'GetFirstClass',
            'GetBrand',
            'GetManufacturers',
            'GetProvince',
            'GetShopClassification',
            'GetDeliveryList',
            'GetActivityTabs'
        ]),
        //
        init() {
            // this.audio = document.getElementById('audio')
            // 用户点击交互之后，设置成能自动播放
            setInterval(() => {
                this._getHomePageData()
            }, 30 * 1000)
        },
        // 售后首页数据 + 响铃
        async _getHomePageData() {
            this.count++
            // 20分刷新一下网页 防止定时器卡
            // if (this.count >= 60 * 2) location.reload()
            const res = await this.$store.dispatch('GetHomeOrderData')
            let exchangeCont, pickCount, replenishCount, returnCount
            if (res) {
                exchangeCont = res.exchangeCont || 0
                pickCount = res.pickCount || 0
                replenishCount = res.replenishCount || 0
                returnCount = res.returnCount || 0

                // 临时队列
                let taskTemp = []
                if (exchangeCont) {
                    taskTemp.push({ type: 'exchangeCont', msg: `您有${exchangeCont}个换货订单未处理`, url: '/order/list-exchange' })
                }
                if (pickCount) {
                    taskTemp.push({ type: 'pickCount', msg: `您有${pickCount}个拣货订单未处理`, url: '/order/picking' })
                }
                if (replenishCount) {
                    taskTemp.push({ type: 'replenishCount', msg: `您有${replenishCount}个补货订单未处理`, url: '/order/list-replenishment' })
                    // await this.showTips('replenishCount')
                }
                if (returnCount) {
                    taskTemp.push({ type: 'returnCount', msg: `您有${returnCount}个退货订单未处理`, url: '/order/list-unsub' })
                }

                taskTemp.forEach((item, index) => {
                    setTimeout(() => {
                        this.task.push({ ...item, uuid: uuidv4() })
                        Notification({ title: '提示：', body: item.msg, url: item.url })
                    }, 3000 * index)
                })

                if (this.total > 0) {
                    this.play = true
                    this.$nextTick(() => {
                        setTimeout(() => {
                            this.play = false
                            this.task.forEach((item, index) => {
                                setTimeout(() => {
                                    this.task.shift(index)
                                }, 3500 * index)
                            })
                        }, 3000)
                    })
                }
            }
        },
        async showTips(type, msg) {
            await this.$notify({
                title: '提示：',
                type: 'error',
                position: 'top-right',
                offset: 80,
                duration: 8000,
                message: msg,
                onClick: () => {}
            })
        },
        // 响铃
        playVoice() {
            // let au = document.getElementById('au')
            // au.innerHTML = `<audio controls="controls" id="audio_player" _style="display:none;" type="audio/mpeg">
            //         <source src="https://img.ddky.com/c/wap/images/test/sounds/tip.mp3" type="audio/mpeg" />
            //     </audio>`
            // let audio = document.getElementById('audio_player')
            // audio.play()
        },

        // 监听页面的点击事件，一旦点过了就能autoplay了
        setAutoPlayWhenClick() {
            let _this = this
            function setAutoPlay() {
                // 设置自动播放为true
                _this.audio.autoplay = true
                document.removeEventListener('mouseover', setAutoPlay)
                document.removeEventListener('click', setAutoPlay)
                document.removeEventListener('touch', setAutoPlay)
            }
            // 检测是否能自动播放
            this.audio = this.$refs.audio
            document.addEventListener('mouseover', setAutoPlay)
            document.addEventListener('click', setAutoPlay)
            document.addEventListener('touch', setAutoPlay)
        },
        // 触发window的resize
        resizeImage() {
            // let event = document.createEvent('HTMLEvents')
            // event.initEvent('resize', true, true)
            window.dispatchEvent(new Event('resize'))
        },
        toggleSideBar() {
            this.$store.dispatch('ToggleSideBar')
            if (this.$route.name === 'ocrManageAdd' || this.$route.name === 'ocrManageShow') {
                setTimeout(() => {
                    this.resizeImage()
                }, 300)
            }
        },
        handleDropdownClick(command) {
            switch (command) {
                case 'changePwd':
                    this.showPwdDialog = true
                    break
                case 'logout':
                    this.$confirm('是否确定退出登录？', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                      return doLogout();
                    }).then(() => {
                      removeToken();
                      location.reload() // 为了重新实例化vue-router对象 避免bug
                      // this.$store.dispatch('LogOut').then(() => {
                      //     location.reload() // 为了重新实例化vue-router对象 避免bug
                      // })
                    })
                    break
                default:
                    break
            }
        },
        handleNotice() {
            this.audio.play()
        }
        // handleWarn() {
        //   this.$router.push('/message/warning')
        // }
    }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.navbar {
    height: $navbar-height;
    line-height: $navbar-height;
    border-radius: 0px !important;
    display: flex;
    .hamburger-container {
        line-height: $navbar-height + 4;
        height: $navbar-height;
        padding: 0 10px;
    }
    .screenfull {
        position: absolute;
        right: 90px;
        top: 16px;
        color: red;
    }
    .title {
        font-size: 20px;
        font-weight: bold;
        color: #59676f;
    }
    .user-content {
        position: absolute;
        right: 30px;
        // width: 280px;
        font-size: 14px;
        display: flex;
        align-items: center;
        justify-content: center;
        .el-dropdown {
            font-size: 14px;
            max-width: 250px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            height: 56px;
            vertical-align: top;
            .el-dropdown-link {
                cursor: pointer;
            }
            .el-dropdown-menu {
                min-width: 180px;
            }
        }
        > span {
            display: inline-block;
            margin: 0 10px;
        }
        .tips {
            height: 60px;
            display: flex;
            align-items: center;
            justify-content: center;
            a {
                margin: 0 5px;
            }
            /deep/ .el-alert {
                padding: 0 5px;

                height: 32px;
                .el-alert__closebtn {
                    top: 11px;
                    right: 10px;
                }
            }
        }
    }
}
.badge-item {
    line-height: 1;
    margin-top: 0px;
    margin-right: 30px;
}
</style>
<style rel="stylesheet/scss" lang="scss">
.bell {
    width: 30px;
    height: 30px;
    .el-icon-bell {
        font-family: 'element-icons' !important;
        // speak: none;
        font-style: normal;
        font-weight: normal;
        font-variant: normal;
        text-transform: none;
        line-height: 1;
        vertical-align: top;
        display: inline-block;
        -webkit-font-smoothing: antialiased;
    }
}
</style>
